import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfileStore } from '../../state/profileStore';

export default function PublicRoute({ children }) {
  const location = useLocation();
  const profile = useProfileStore((s) => s.profile);

  const path = location.pathname || '';
  const isPublicCompany = path.startsWith('/company/public/');
  const isReviewPage = path.startsWith('/review/');

  // If logged in, send users away from public pages (allow public company + review pages)
  if (profile && !isPublicCompany && !isReviewPage) {
    return <Navigate to="/profile" replace />;
  }

  return children;
}
